import React from "react";

import { BetOffer } from "@models";
import LinkActiveEventsHOC from "./LinkActiveEventsHOC";

export default function NormalEventData(props: { offer: BetOffer }) {
	const eventNameStr =
		props.offer.hasOwnProperty("isMulti") && props.offer.isMulti == true
			? props.offer.multiEventName
			: props.offer.sportData.eventName;

	return (
		<td className="table--bets__td table--bets__td--event">
			<LinkActiveEventsHOC
				eventId={props.offer.eventId}
				className="table--bets__td--link"
				isLive={props.offer.isLive}
			>
				{eventNameStr}
			</LinkActiveEventsHOC>
		</td>
	);
}
